import { DebounceSettings, debounce } from 'lodash'

/** How many ms to wait before debounced action is called */
export const DEBOUNCE_TIMEOUT = 600

/** Higher order function generating debounced version of passed function */
export const getDebouncedFunction = <T extends unknown[] = any[], R = unknown>(fnc: (...args: T) => R, debounceTimeout: number, options?: DebounceSettings) => debounce(fnc, debounceTimeout, options)
